import { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card'
import { FaSearch } from 'react-icons/fa';
import { MdDeleteForever } from "react-icons/md";
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Dropdown from 'react-bootstrap/Dropdown';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import LoadingComponent from './../../widgets/LoadingComponent';
import { updateEmpresaResolucionFactura, updateEmpresaResolucionNotaDebito_Credito } from '../empresa/EmpresaApi'
import { getData } from './../../api/ApiRest'
import Form from 'react-bootstrap/Form';
import { formatDateddMMMyyyy } from './../../widgets/DateTime'
import { confirmAlert } from 'react-confirm-alert';
import auditoriaSet from '../../widgets/Auditoria';



function Resoluciones({ CompanySelect, FacturacionAmbiente, Permiso, GestionResoluc, Es_Cliente }) {
    const [loading, setLoading] = useState(false);
    const [nuevoBtn, setNuevoBtn] = useState({
        Fv: false, FvE: false, FvC: false, Nc: false, Nd: false, NominaInd: false,
        NominaAjuste: false, DocSoporte: false, DocSoporteAjuste: false,
        Pos: false, PosNc: false, PosNd: false
    });
    const [typeDocuments, setTypeDocuments] = useState({ TypeDocuemnts: [], TypeDocumentid: '', Prefix: '' });
    const [resolutions, setResolutions] = useState([]);
    const [facturaData, setFacturaData] = useState({
        type_document_id: '1',
        prefix: '', resolution: '',
        resolution_date: 'yyyy-mm-dd', technical_key: '', from: 0, to: 0,
        generated_to_date: 0, date_from: 'yyyy-mm-dd', date_to: 'yyyy-mm-dd'
    });
    const [notaData, setNotaData] = useState({
        "type_document_id": null, "from": 0,
        "to": 0, "prefix": '', "resolution": "1",
    });
    const [documentoSoporte, setDocumentoSoporte] = useState({
        "type_document_id": 11,
        "prefix": "SEDS",
        "resolution": "18760000001",
        "resolution_date": "2022-01-01",
        "from": 984000000,
        "to": 985000000,
        "generated_to_date": 0,
        "date_from": "2022-01-01",
        "date_to": "2022-12-31"
    });
    const [posFactura, setPosFactura] = useState({
        "type_document_id": 15,
        "prefix": "EPOS",
        "resolution": "18760000001",
        "resolution_date": "2019-01-19",
        "from": 1,
        "to": 1000,
        "generated_to_date": 0,
        "date_from": "2019-01-19",
        "date_to": "2030-01-19"
    });


    const limpiarForms = () => {
        setNuevoBtn({
            Fv: false, FvC: false, Nc: false, Nd: false, NominaInd: false, NominaAjuste: false,
            DocSoporte: false, DocSoporteAjuste: false, Pos: false, PosNc: false, PosNd: false
        });
        setNotaData({ "type_document_id": null, "from": 0, "to": 0, "prefix": '' });
        setFacturaData({
            prefix: '', resolution: '',
            resolution_date: 'yyyy-mm-dd', technical_key: '', from: 0, to: 0,
            generated_to_date: 0, date_from: 'yyyy-mm-dd', date_to: 'yyyy-mm-dd'
        });
        setPosFactura({
            "type_document_id": 15,
            "prefix": "EPOS",
            "resolution": "18760000001",
            "resolution_date": "2019-01-19",
            "from": 1,
            "to": 1000,
            "generated_to_date": 0,
            "date_from": "2019-01-19",
            "date_to": "2030-01-19"
        });
    }

    useEffect(() => {
        initForm();
    }, [])

    const initForm = () => {
        limpiarForms();
        setLoading(true);

        getData('api/Configuracion/Company/ResolutionGetInfo', {}, true).then(response => {
            if (response.status === true) {
                setTypeDocuments({ TypeDocuemnts: response.typesDocuments, TypeDocumentid: '' });
            }
            else {
                alert('algo salio mal');
            }

            setLoading(false);
        }, error => {
            alert('Algo salio mal al cargar los tipos de documentos');
            console.log(error);
            setLoading(false);
        })
    }


    const buscarResolutions = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/Company/ResolutionGetData', {
            Companyid: CompanySelect.id,
            TypeDocumentid: typeDocuments.TypeDocumentid,
            Prefix: typeDocuments.Prefix || ''
        }, false).then(response => {

            if (response.status === true) {
                setResolutions(response.resolutions);
            }
            else {
                alert('algo salio mal al buscar las resoluciones');
            }

            setLoading(false);
        }, error => {
            alert('Algo salio mal al buscar las resoluciones');
            console.log(error);
            setLoading(false);
        })
    }


    const facturaResolutionSave = (event) => {
        if (!GestionResoluc) {
            alert('No tienes permiso para editar resoluciones');
            return;
        }

        setLoading(true);
        event.preventDefault();

        updateEmpresaResolucionFactura(facturaData, CompanySelect.user_Api_Token).then(response => {
            alert(response.message);
            if (response.success === true) {
                initForm();

                ///Función para guardar la auditoría 
                auditoriaSet(facturaData, {}, 'C', 'Empresa', CompanySelect.id, 'Resolución');

                buscarResolutions();
            }
            else {
                alert(JSON.stringify(response.errors));
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('algo salio mal');
        })
    }


    const posFVResolutionSave = (event) => {
        if (!GestionResoluc) {
            alert('No tienes permiso para editar resoluciones');
            return;
        }
        setLoading(true);
        event.preventDefault();

        updateEmpresaResolucionNotaDebito_Credito(posFactura, CompanySelect.user_Api_Token).then(response => {
            alert(response.message);
            if (response.success === true) {
                initForm();

                ///Función para guardar la auditoría 
                auditoriaSet(posFactura, {}, 'C', 'Empresa', CompanySelect.id, 'Resolución');

                buscarResolutions();
            }
            else {
                alert(JSON.stringify(response.errors));
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('algo salio mal');
        })
    }


    const notaDBNCSave = (event) => {
        if (!GestionResoluc) {
            alert('No tienes permiso para editar resoluciones');
            return;
        }
        setLoading(true);
        event.preventDefault();

        updateEmpresaResolucionNotaDebito_Credito(notaData, CompanySelect.user_Api_Token).then(response => {
            alert(response.message);
            if (response.success === true) {
                initForm();

                ///Función para guardar la auditoría 
                auditoriaSet(notaData, {}, 'C', 'Empresa', CompanySelect.id, 'Resolución');

                buscarResolutions();
            }
            else {
                alert(JSON.stringify(response.errors));
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('algo salio mal');
        })

    }

    const documentoSoporteSave = (event) => {
        if (!GestionResoluc) {
            alert('No tienes permiso para editar resoluciones');
            return;
        }
        setLoading(true);
        event.preventDefault();

        updateEmpresaResolucionNotaDebito_Credito(documentoSoporte, CompanySelect.user_Api_Token).then(response => {
            alert(response.message);
            if (response.success === true) {
                initForm();

                ///Función para guardar la auditoría 
                auditoriaSet(documentoSoporte, {}, 'C', 'Empresa', CompanySelect.id, 'Resolución');

                buscarResolutions();
            }
            else {
                alert(JSON.stringify(response.errors));
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('algo salio mal');
        })
    }


    const labelFormNuevo = () => {
        if (nuevoBtn.Fv === true)
            return 'Nueva Resolucion de factura de venta electronica';
        else if (nuevoBtn.FvE === true)
            return 'Nueva Resolucion de factura de Exportacion';
        else if (nuevoBtn.FvC === true)
            return 'Nueva Resolucion de factura de Contingencia';
        else if (nuevoBtn.Nc === true)
            return 'Nueva Nota Credito';
        else if (nuevoBtn.Nd === true)
            return 'Nueva Nota Debito';
        else if (nuevoBtn.NominaInd === true)
            return 'Nueva Emisión de Nomina Individual';
        else if (nuevoBtn.NominaAjuste === true)
            return 'Nueva Nota de Ajuste de Nomina';
        else if (nuevoBtn.Pos === true)
            return 'Nueva factura POS';
        else if (nuevoBtn.PosNc === true)
            return 'Nueva Nota Credito POS';
        else if (nuevoBtn.PosNd === true)
            return 'Nueva Nota Debito POS';

    }


    const formNuevo = () => {
        if (nuevoBtn.Fv === true || nuevoBtn.FvE === true || nuevoBtn.FvC === true) {
            return <Card className='mt-3'>
                <Card.Header>Nueva resolucion de facturacion</Card.Header>
                <Card.Body>
                    <form onSubmit={facturaResolutionSave}>
                        <div className='row'>
                            <div className='col-md-3'>
                                <FloatingLabel
                                    controlId="Prefijo"
                                    label="Prefijo"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Prefijo"
                                        value={facturaData.prefix}
                                        onChange={value => setFacturaData({ ...facturaData, prefix: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className='col-md-5'>
                                <FloatingLabel
                                    controlId="Resolucion No"
                                    label="Resolucion"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion No"
                                        value={facturaData.resolution}
                                        onChange={value => setFacturaData({ ...facturaData, resolution: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="ResolucionFecha"
                                    label="Fecha Resolucion"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Fecha Resolucion"
                                        value={facturaData.resolution_date}
                                        onChange={value => {
                                            setFacturaData({ ...facturaData, resolution_date: value.target.value })
                                        }}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-6'>
                                <FloatingLabel
                                    controlId="ResolucionDesde"
                                    label="Resolucion Desde"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Desde"
                                        value={facturaData.from}
                                        onChange={value => setFacturaData({ ...facturaData, from: value.target.valueAsNumber })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-6'>
                                <FloatingLabel
                                    controlId="Resolucionhasta"
                                    label="Resolucion Hasta"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Hasta"
                                        value={facturaData.to}
                                        onChange={value => setFacturaData({ ...facturaData, to: value.target.valueAsNumber })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-6'>
                                <FloatingLabel
                                    controlId="ResolucionDateFrom"
                                    label="Fecha Resolucion Desde"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Fecha Resolucion Desde"
                                        value={facturaData.date_from}
                                        onChange={value => setFacturaData({ ...facturaData, date_from: (value.target.value) })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-6'>
                                <FloatingLabel
                                    controlId="ResolucionDateTo"
                                    label="Fecha Resolucion Hasta"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Fecha Resolucion Hasta"
                                        value={facturaData.date_to}
                                        onChange={value => setFacturaData({ ...facturaData, date_to: (value.target.value) })}
                                    />
                                </FloatingLabel>
                            </div>


                            <div className='col-md-12'>
                                <FloatingLabel
                                    controlId="ResolucionKey"
                                    label="Lave Tecnica"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Llave tecnica"
                                        value={facturaData.technical_key}
                                        onChange={value => setFacturaData({ ...facturaData, technical_key: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-2'>

                                <Button type='button' variant='danger' title='Cancelar' onClick={() => {
                                    limpiarForms();
                                }}>
                                    Cancelar
                                </Button>

                            </div>

                            <div className='col-md-2'>
                                <Button type='submit' variant='success' title='Guardar'>
                                    Guardar
                                </Button>
                            </div>

                        </div>
                    </form>
                </Card.Body>
            </Card>
        }
        else if (nuevoBtn.Nc === true || nuevoBtn.Nd === true || nuevoBtn.NominaInd === true ||
            nuevoBtn.NominaAjuste === true || nuevoBtn.DocSoporteAjuste === true ||
            nuevoBtn.PosNc === true || nuevoBtn.PosNd === true) {
            return <Card className='mt-3'>
                <Card.Header>{labelFormNuevo()}</Card.Header>
                <Card.Body>
                    <br></br>
                    <form onSubmit={notaDBNCSave}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="Prefijo"
                                    label="Prefijo"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Prefijo"
                                        value={notaData.prefix}
                                        onChange={value => setNotaData({ ...notaData, prefix: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="ResNcDesde"
                                    label="Resolucion Desde"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        min={0}
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Desde"
                                        value={notaData.from}
                                        onChange={value => setNotaData({ ...notaData, from: value.target.valueAsNumber })}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="ResNcHasta"
                                    label="Resolucion Hasta"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        min={0}
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Hasta"
                                        value={notaData.to}
                                        onChange={value => setNotaData({ ...notaData, to: value.target.valueAsNumber })}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className='col-md-5'>
                                <FloatingLabel
                                    controlId="Resolucion No"
                                    label="Resolucion"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion No"
                                        value={notaData.resolution}
                                        onChange={value => setNotaData({ ...notaData, resolution: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-2'>

                                <Button type='button' variant='danger' title='Cancelar' onClick={() => {
                                    limpiarForms();
                                }}>
                                    Cancelar
                                </Button>

                            </div>

                            <div className='col-md-2'>
                                <Button type='submit' variant='success' title='Guardar'>
                                    Guardar
                                </Button>
                            </div>

                        </div>
                    </form>
                </Card.Body>
            </Card>
        }
        else if (nuevoBtn.DocSoporte === true) {
            return <Card className='mt-3'>
                <Card.Header>Nuevo Documento de Soporte</Card.Header>
                <Card.Body>
                    <form onSubmit={documentoSoporteSave}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="Prefijo"
                                    label="Prefijo"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Prefijo"
                                        value={documentoSoporte.prefix}
                                        onChange={value => setDocumentoSoporte({ ...documentoSoporte, prefix: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-8'>
                                <FloatingLabel
                                    controlId="DocSoporteResolucion"
                                    label="Prefijo"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion"
                                        value={documentoSoporte.resolution}
                                        onChange={value => setDocumentoSoporte({ ...documentoSoporte, resolution: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="DocSoporteResolucionFecha"
                                    label="Resolucion Fecha"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="yyyy-MM-dd"
                                        value={documentoSoporte.resolution_date}
                                        onChange={value => setDocumentoSoporte({ ...documentoSoporte, resolution_date: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="DocSoporteResolucionDesde"
                                    label="Resolucion Desde"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Desde"
                                        value={documentoSoporte.from}
                                        onChange={value => setDocumentoSoporte({ ...documentoSoporte, from: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="DocSoporteResolucionHasta"
                                    label="Resolucion Hasta"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Hasta"
                                        value={documentoSoporte.to}
                                        onChange={value => setDocumentoSoporte({ ...documentoSoporte, to: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="DocSoporteFechaDesde"
                                    label="Fecha Desde"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="yyyy-MM-dd"
                                        value={documentoSoporte.date_from}
                                        onChange={value => setDocumentoSoporte({ ...documentoSoporte, date_from: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="DocSoporteFechaHasta"
                                    label="Fecha Hasta"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="yyyy-MM-dd"
                                        value={documentoSoporte.date_to}
                                        onChange={value => setDocumentoSoporte({ ...documentoSoporte, date_to: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-2'>

                                <Button type='button' variant='danger' title='Cancelar' onClick={() => {
                                    limpiarForms();
                                }}>
                                    Cancelar
                                </Button>

                            </div>

                            <div className='col-md-2'>
                                <Button type='submit' variant='success' title='Guardar'>
                                    Guardar
                                </Button>
                            </div>

                        </div>
                    </form>
                </Card.Body>
            </Card>
        }
        else if (nuevoBtn.Pos === true) {
            return <Card className='mt-3'>
                <Card.Header>{labelFormNuevo()}</Card.Header>
                <Card.Body>
                    <form onSubmit={posFVResolutionSave}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="Prefijo"
                                    label="Prefijo"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Prefijo"
                                        value={posFactura.prefix}
                                        onChange={value => setPosFactura({ ...posFactura, prefix: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-8'>
                                <FloatingLabel
                                    controlId="POSResolucion"
                                    label="Resolucion"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion"
                                        value={posFactura.resolution}
                                        onChange={value => setPosFactura({ ...posFactura, resolution: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="PosResolucionFecha"
                                    label="Resolucion Fecha"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="yyyy-MM-dd"
                                        value={posFactura.resolution_date}
                                        onChange={value => setPosFactura({ ...posFactura, resolution_date: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="PosResolucionDesde"
                                    label="Resolucion Desde"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Desde"
                                        value={posFactura.from}
                                        onChange={value => setPosFactura({ ...posFactura, from: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="PosResolucionHasta"
                                    label="Resolucion Hasta"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="number"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="Resolucion Hasta"
                                        value={posFactura.to}
                                        onChange={value => setPosFactura({ ...posFactura, to: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="PosFechaDesde"
                                    label="Fecha Desde"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="yyyy-MM-dd"
                                        value={posFactura.date_from}
                                        onChange={value => setPosFactura({ ...posFactura, date_from: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="PosFechaHasta"
                                    label="Fecha Hasta"
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        autoComplete='off'
                                        placeholder="yyyy-MM-dd"
                                        value={posFactura.date_to}
                                        onChange={value => setPosFactura({ ...posFactura, date_to: value.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-2'>

                                <Button type='button' variant='danger' title='Cancelar' onClick={() => {
                                    limpiarForms();
                                }}>
                                    Cancelar
                                </Button>

                            </div>

                            <div className='col-md-2'>
                                <Button type='submit' variant='success' title='Guardar'>
                                    Guardar
                                </Button>
                            </div>

                        </div>
                    </form>
                </Card.Body>
            </Card>
        }
    }


    const actualizarResoluciones = () => {
        if (!GestionResoluc) {
            alert('No tienes permiso para editar resoluciones');
            return;
        }

        setLoading(true);
        getData('api/Configuracion/Company/ResolutionGetRanges', {
            CompanyId: CompanySelect.id
        }, false).then(response => {
            console.log(response);
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal, por favor verifica')
        })
    }

    const eliminarResolucion = (item) => {
        if (!Permiso) {
            alert('No tienes permiso para eliminar resoluciones');
            return;
        }

        const options = {
            title: 'Eliminar Resolución',
            message: '¿Esta seguro que desea eliminar esta resolución, esta acción es irreversible?',
            buttons: [
                {
                    label: 'Si',
                    onClick: () => eliminarResolucionConfirm(item)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            willUnmount: () => { },
            afterClose: () => { },
            onClickOutside: () => { },
            onKeypress: () => { },
            onKeypressEscape: () => { },
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options);
    }


    const eliminarResolucionConfirm = (item) => {
        setLoading(true);

        setLoading(true);
        getData('api/Configuracion/Company/ResolutionDelete', {
            CompanyId: CompanySelect.id,
            Resolutionid: item.id
        }, false).then(response => {

            if (response.status === true) {
                alert('Resolucion eliminada con exito');

                ///Función para guardar la auditoría de las resoluciones
                auditoriaSet(item, {}, 'E', 'Empresa', CompanySelect.id, 'Resolución');

                buscarResolutions();
            }
            else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal, por favor verifica')
        })
    }



    const buttonNuevo = () => {
        if (nuevoBtn.Fv === false && nuevoBtn.Nc === false && nuevoBtn.Nd === false
            && nuevoBtn.NominaInd === false && nuevoBtn.NominaAjuste === false &&
            nuevoBtn.DocSoporte === false && nuevoBtn.DocSoporteAjuste === false) {
            return <div className='row'>

                <div className='col-md-8'>
                    <DropdownButton
                        className='m-2'
                        bsPrefix='btn btn-sm btn-secondary'
                        as={ButtonGroup}
                        title="Facturacion Electronica" id="bg-nested-dropdown">
                        <Dropdown.Item eventKey="1"
                            onClick={() => {
                                setFacturaData({ ...facturaData, type_document_id: '1' })
                                setNuevoBtn({ ...nuevoBtn, Fv: true });
                            }}>Factura de Venta</Dropdown.Item>
                        <Dropdown.Item eventKey="1"
                            onClick={() => {
                                setFacturaData({ ...facturaData, type_document_id: '2' })
                                setNuevoBtn({ ...nuevoBtn, FvE: true });
                            }}>Factura de Exportacion</Dropdown.Item>
                        <Dropdown.Item eventKey="1"
                            onClick={() => {
                                setFacturaData({ ...facturaData, type_document_id: '3' })
                                setNuevoBtn({ ...nuevoBtn, FvC: true });
                            }}>Factura de Contingencia</Dropdown.Item>

                        <Dropdown.Item eventKey="2"
                            onClick={() => {
                                setNuevoBtn({ ...nuevoBtn, Nc: true });
                                setNotaData({ ...notaData, type_document_id: 4 });
                            }}>
                            Nota Credito
                        </Dropdown.Item>

                        <Dropdown.Item eventKey="3"
                            onClick={() => {
                                setNuevoBtn({ ...nuevoBtn, Nd: true });
                                setNotaData({ ...notaData, type_document_id: 5 });
                            }}>
                            Nota Debito
                        </Dropdown.Item>
                    </DropdownButton>

                    <DropdownButton
                        className='m-2'
                        bsPrefix='btn btn-sm btn-secondary'
                        as={ButtonGroup}
                        title="Nomina"
                        id="bg-nested-dropdown">
                        <Dropdown.Item eventKey="2"
                            onClick={() => {
                                setNuevoBtn({ ...nuevoBtn, NominaInd: true });
                                setNotaData({ ...notaData, type_document_id: 9 });
                            }}>
                            Nomina Individual
                        </Dropdown.Item>

                        <Dropdown.Item eventKey="3"
                            onClick={() => {
                                setNuevoBtn({ ...nuevoBtn, NominaAjuste: true });
                                setNotaData({ ...notaData, type_document_id: 10 });
                            }}>
                            Nomina Nota de ajuste
                        </Dropdown.Item>
                    </DropdownButton>

                    <DropdownButton
                        className='m-2'
                        bsPrefix='btn btn-sm btn-secondary'
                        as={ButtonGroup}
                        title="Soporte"
                        id="bg-nested-dropdown">
                        <Dropdown.Item eventKey="2"
                            onClick={() => {
                                setNuevoBtn({ ...nuevoBtn, DocSoporte: true });
                                setDocumentoSoporte({ ...documentoSoporte, type_document_id: 11 });
                            }}>
                            Documento de Soporte
                        </Dropdown.Item>

                        <Dropdown.Item eventKey="3"
                            onClick={() => {
                                setNuevoBtn({ ...nuevoBtn, DocSoporteAjuste: true });
                                setNotaData({ ...notaData, type_document_id: 13 });
                            }}>
                            Documento de Soporte Ajuste
                        </Dropdown.Item>
                    </DropdownButton>

                    <DropdownButton
                        className='m-2'
                        bsPrefix='btn btn-sm btn-secondary'
                        as={ButtonGroup}
                        title="Equivalentes"
                        id="bg-nested-dropdown">
                        <Dropdown.Item eventKey="1" onClick={() => {
                            setNuevoBtn({ ...nuevoBtn, Pos: true });
                            setNotaData({ ...notaData, type_document_id: 15 });
                        }}>POS</Dropdown.Item>

                        <Dropdown.Item eventKey="2" onClick={() => {
                            setNuevoBtn({ ...nuevoBtn, PosNc: true });
                            setNotaData({ ...notaData, type_document_id: 26 });
                        }}>
                            POS NC
                        </Dropdown.Item>

                        <Dropdown.Item eventKey="3" onClick={() => {
                            setNuevoBtn({ ...nuevoBtn, PosNd: true });
                            setNotaData({ ...notaData, type_document_id: 25 });
                        }}>
                            POS ND
                        </Dropdown.Item>
                    </DropdownButton>
                </div>

                {FacturacionAmbiente === '1' ?
                    <div className='col-md-2'>
                        <button type='button' className='btn btn-sm btn-danger'
                            onClick={actualizarResoluciones}
                        >
                            Actualizar Resoluciones
                        </button>
                    </div>
                    : null}


            </div>
        }
    }


    return <div>
        {Es_Cliente === 'true' ? <>{buttonNuevo()}</> : null}

        {<LoadingComponent Loading={loading} />}

        {formNuevo()}

        <Form onSubmit={(e) => buscarResolutions(e)}>
            <div className='row mt-3'>
                <div className='col-md-4'>
                    <FloatingLabel
                        controlId='floatingTipoDocumento'
                        label="Tipo Documento"
                        className="mb-3"
                    >
                        <Form.Select
                            value={typeDocuments.TypeDocumentid}
                            onChange={event => {
                                setTypeDocuments({
                                    ...typeDocuments,
                                    TypeDocumentid: event.target.value
                                })
                            }}
                        >
                            <option value="">Todos</option>
                            {typeDocuments.TypeDocuemnts.map((item, key) =>
                                <option key={key} value={item.value}>{item.text}</option>)}
                        </Form.Select>
                    </FloatingLabel>
                </div>
                <div className='col-md-4'>
                    <FloatingLabel
                        controlId='floatingPrefijo'
                        label="Prefijo"
                        className="mb-3"
                    >
                        <Form.Control
                            as="input"
                            type='text'
                            placeholder="Prefijo"
                            rows={1}
                            value={typeDocuments.Prefix}
                            onChange={event => setTypeDocuments({ ...typeDocuments, Prefix: event.target.value })}
                            autoComplete='off'
                        />
                    </FloatingLabel>
                </div>
                <div className='col-md-2'>
                    <Button type='submit' variant='primary' title='Buscar'>
                        <FaSearch size={'1rem'} />
                    </Button>
                </div>
            </div>
        </Form>


        <div className='table-responsive mt-2'>
            <table className='table table-sm table-bordered table-hover'>
                <thead>
                    <tr className='table-dark'>
                        {Es_Cliente === 'true' ? <th></th> : null}
                        <th>
                            Tipo
                        </th>
                        <th>
                            Prefijo
                        </th>
                        <th>
                            Desde
                        </th>
                        <th>
                            Hasta
                        </th>
                        <th>
                            Resolución #
                        </th>
                        <th>
                            Vencimiento
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {resolutions.map((item, key) => (
                        <tr key={key}>
                            {Es_Cliente === 'true' ? <td className='text-center'>
                                <Button type='button' variant='danger'
                                    title='Eliminar resolucion' onClick={() => eliminarResolucion(item)}>
                                    <MdDeleteForever size={'1rem'} />
                                </Button>
                            </td> : null}
                            <td className='text-center'>
                                {item.typeDocument}
                            </td>
                            <td className='text-center'>
                                {item.prefix}
                            </td>
                            <td className='text-center'>
                                {item.from}
                            </td>
                            <td className='text-center'>
                                {item.to}
                            </td>
                            <td className='text-center'>
                                {item.resolution}
                            </td>
                            <td className='text-center'>
                                {formatDateddMMMyyyy(item.date_To)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

    </div>

}

export default Resoluciones;
